// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import BodyCopy from '../../../../../../../common/atoms/BodyCopy';
import withStyles from '../../../../../../../common/hoc/withStyles';
import styles from '../../styles/RewardsPoints.style';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '../../../../../../../../utils/labels/labelUtilty';
import {
  GLOBAL_GENERIC_LABELS,
  GlobalGenericLabels,
  lblCurrency,
} from '../../../../../../../../utils/labels/globalGeneric.labels';
import AccountCommonLabels, { GLOBAL_LABELS } from '../../../../labels/AccountCommon.labels';

/**
 * @function RewardsPointsView The RewardsPointsView component will provide slider for account drawer
 */

const getPointsColor = (isPlcc) => (isPlcc ? 'blue.B100' : 'orange.800');

const RewardsPointsTable = ({
  className,
  pointsToNextReward,
  currentPoints,
  totalRewards,
  plccUser,
}) => {
  const globalLabels = getLabelFromCopyOrFromTranslation(GLOBAL_LABELS, AccountCommonLabels);

  return (
    <div className={className}>
      <BodyCopy component="div" className="table-container">
        <BodyCopy component="div" className="table-item">
          <BodyCopy
            fontSize="fs20"
            fontWeight="extrabold"
            fontFamily="secondary"
            textAlign="center"
            color={getPointsColor(plccUser)}
          >
            {getLabelFromCopyOrFromTranslation(
              `${GLOBAL_GENERIC_LABELS}.${lblCurrency}`,
              GlobalGenericLabels
            )}
            {totalRewards && Math.trunc(totalRewards)}
          </BodyCopy>
          <BodyCopy fontSize="fs14" textAlign="center" fontFamily="secondary">
            {renderLabel(
              globalLabels?.rewardPoints?.lbl_rewardPoints_heading,
              'lbl_rewardPoints_heading'
            )}
          </BodyCopy>
        </BodyCopy>
        <BodyCopy component="div" className="table-item">
          <BodyCopy
            textAlign="center"
            fontSize="fs20"
            fontWeight="extrabold"
            fontFamily="secondary"
            color={getPointsColor(plccUser)}
          >
            {currentPoints}
          </BodyCopy>
          <BodyCopy fontSize="fs14" textAlign="center" fontFamily="secondary">
            {renderLabel(
              globalLabels?.rewardPoints?.lbl_rewardPoints_currentPoints,
              'lbl_rewardPoints_currentPoints'
            )}
          </BodyCopy>
        </BodyCopy>
        <BodyCopy component="div" className="table-item">
          <BodyCopy
            textAlign="center"
            fontSize="fs20"
            fontWeight="extrabold"
            fontFamily="secondary"
            color={getPointsColor(plccUser)}
          >
            {pointsToNextReward}
          </BodyCopy>
          <BodyCopy fontSize="fs14" textAlign="center" fontFamily="secondary">
            {renderLabel(
              globalLabels?.rewardPoints?.lbl_rewardPoints_nextReward,
              'lbl_rewardPoints_nextReward'
            )}
          </BodyCopy>
        </BodyCopy>
      </BodyCopy>
    </div>
  );
};

RewardsPointsTable.propTypes = {
  className: PropTypes.string,
  pointsToNextReward: PropTypes.string,
  currentPoints: PropTypes.string,
  totalRewards: PropTypes.string,
  plccUser: PropTypes.bool.isRequired,
};

RewardsPointsTable.defaultProps = {
  className: '',
  pointsToNextReward: '',
  currentPoints: '',
  totalRewards: '',
};

export default withStyles(RewardsPointsTable, styles);
export { RewardsPointsTable as RewardsPointsTableVanilla };
